import { handleActions } from 'redux-actions';
import { chatFlowsActions } from '../actions/chatFlows';
export const { chatFlowsGetAll, chatFlowsGetAllSucceeded, chatFlowsGetAllFailed, } = chatFlowsActions;
// Init state for the Chat Flows.
const initialState = {
    chatFlows: [],
    meta: {
        asyncStatus: 'succeeded',
    },
};
// Reducer
const chatFlows = handleActions({
    [chatFlowsGetAll.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [chatFlowsGetAllSucceeded.toString()]: (state, action) => {
        const flows = action.payload.data &&
            action.payload.data.conversation_flows &&
            Array.isArray(action.payload.data.conversation_flows)
            ? action.payload.data.conversation_flows
            : [];
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }), chatFlows: flows });
    },
    [chatFlowsGetAllFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
}, initialState);
export default chatFlows;
